export default {
  "news": {
    "title": "Notícias",
    "learn_more": "Saiba mais",
    "back_to_home": "Retornar para Home",
    "not_found": "Notícia não encontrada"
  }
}
